import { motion } from 'framer-motion';
import { useState } from 'react';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import SEOHead from '../../components/SEOHead';

export default function DienstenInterieurPage() {
  const [activeService, setActiveService] = useState(0);
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://dsfcartech.be';

  const services = [
    {
      id: 'sterrenhemel',
      icon: 'ri-sparkling-2-line',
      title: 'Sterrenhemel',
      subtitle: 'Luxe hemelplafond',
      description: 'Sterrenhemel installeren Antwerpen - Transformeer uw auto-interieur met een adembenemende sterrenhemel. Duizenden glasvezelsterren creëren een magische sfeer in uw Rolls-Royce, BMW, Mercedes of andere luxe auto.',
      longDescription: 'Bij DSF Cartech in Antwerpen installeren wij professionele sterrenhemel plafonds in uw auto. Sterrenhemel auto installatie Antwerpen is onze specialiteit - met duizenden individuele glasvezelpunten creëren wij een prachtig nachtelijk hemelbeeld in uw hemelplafond. Perfect voor luxe merken zoals Rolls-Royce, Bentley, BMW, Mercedes, Audi en meer. Elke installatie is volledig op maat gemaakt en kan worden aangepast in kleur, helderheid en patroon. De sterrenhemel kan zelfs twinkelen voor een extra realistisch effect. Wij bedienen klanten in heel de regio Antwerpen: Wommelgem, Mortsel, Kontich, Edegem, Schoten, Brasschaat, Wijnegem, Deurne, Berchem en omstreken. Sterrenhemel plafond auto Antwerpen - voor een luxe rijervaring die u nooit zult vergeten.',
      benefits: [
        'Duizenden individuele glasvezelsterren - sterrenhemel Antwerpen',
        'Instelbare helderheid en kleur (wit, blauw, RGB)',
        'Optioneel twinkeling effect voor realisme',
        'Volledig op maat gemaakt voor uw auto',
        'Professionele installatie zonder schade aan interieur',
        'Compatibel met alle automerken in regio Antwerpen',
      ],
      useCases: [
        { title: 'Luxe sfeer', desc: 'Rolls-Royce stijl sterrenhemel in elke auto - Antwerpen' },
        { title: 'Romantisch', desc: 'Perfect voor speciale momenten en avondritten' },
        { title: 'Uniek', desc: 'Maak uw auto echt uniek en opvallend' },
        { title: 'Waarde', desc: 'Verhoogt de waarde en aantrekkelijkheid van uw auto' },
      ],
      image: 'https://static.readdy.ai/image/9e62058216dff63d1a686833c97014ce/b97434262329e812a17292bb4b7d2069.jpeg',
      features: [
        { icon: 'ri-star-line', title: 'Duizenden sterren', desc: 'Glasvezel technologie' },
        { icon: 'ri-palette-line', title: 'Kleur keuze', desc: 'Wit, blauw of RGB' },
        { icon: 'ri-flashlight-line', title: 'Dimbaar', desc: 'Instelbare helderheid' },
        { icon: 'ri-magic-line', title: 'Twinkeling', desc: 'Realistisch effect' },
      ],
      color: 'from-purple-400 to-pink-500',
      glowColor: 'purple',
    },
    {
      id: 'sfeerverlichting',
      icon: 'ri-lightbulb-flash-line',
      title: 'Sfeerverlichting',
      subtitle: 'Ambient lighting systemen',
      description: 'Sfeerverlichting auto installeren Antwerpen - Upgrade uw interieur met professionele ambient lighting. RGB LED strips voor deuren, dashboard, voetenruimte en meer. Volledig instelbaar via app of afstandsbediening.',
      longDescription: 'Transformeer uw auto-interieur met professionele sfeerverlichting van DSF Cartech in Antwerpen. Ambient lighting installatie Antwerpen voor alle automerken - wij installeren hoogwaardige RGB LED strips op strategische locaties in uw auto: deuren, dashboard, middenconsole, voetenruimte, bekerhouders en meer. De verlichting is volledig instelbaar in kleur, helderheid en effect (statisch, fade, strobe, muziek sync). Bedien alles via een handige smartphone app of afstandsbediening. Perfect voor BMW, Mercedes, Audi, Volkswagen en andere merken die u wilt upgraden naar moderne ambient lighting zoals in nieuwere modellen. Wij bedienen de hele regio Antwerpen: Wommelgem, Mortsel, Kontich, Edegem, Schoten, Brasschaat, Wijnegem en omstreken. Sfeerverlichting auto Antwerpen - voor een luxe en moderne uitstraling.',
      benefits: [
        'RGB LED strips - 16 miljoen kleuren mogelijk',
        'Sfeerverlichting installeren Antwerpen - alle locaties',
        'App bediening via smartphone (iOS & Android)',
        'Muziek synchronisatie - verlichting beweegt op beat',
        'Verschillende effecten: fade, strobe, rainbow, etc.',
        'Professionele installatie zonder zichtbare bedrading',
      ],
      useCases: [
        { title: 'Deuren', desc: 'Ambient lighting in deurpanelen - Antwerpen installatie' },
        { title: 'Dashboard', desc: 'Verlichtinging rondom dashboard en middenconsole' },
        { title: 'Voetenruimte', desc: 'LED strips onder stoelen en in voetenruimte' },
        { title: 'Bekerhouders', desc: 'Verlichte bekerhouders en opbergvakken' },
      ],
      image: 'https://static.readdy.ai/image/9e62058216dff63d1a686833c97014ce/ad27e1100c1f7902ebe33adb942824ab.jpeg',
      features: [
        { icon: 'ri-palette-line', title: '16M kleuren', desc: 'RGB LED technologie' },
        { icon: 'ri-smartphone-line', title: 'App control', desc: 'Controle via smartphone' },
        { icon: 'ri-music-line', title: 'Muziek sync', desc: 'Reageert op muziek' },
        { icon: 'ri-flashlight-line', title: 'Effecten', desc: 'Fade, strobe, etc.' },
      ],
      color: 'from-pink-400 to-rose-500',
      glowColor: 'pink',
    },
    {
      id: 'achteruitrijcamera',
      icon: 'ri-camera-line',
      title: 'Achteruitrijcamera',
      subtitle: 'Veilig parkeren en manoeuvreren',
      description: 'Achteruitrijcamera installeren Antwerpen - Verhoog de veiligheid met een professionele achteruitrijcamera. HD beeldkwaliteit, parkeerhulplijnen en nachtzicht voor veilig parkeren in elke situatie.',
      longDescription: 'Veilig parkeren en manoeuvreren met een professionele achteruitrijcamera van DSF Cartech in Antwerpen. Achteruitrijcamera installatie Antwerpen voor alle automerken - wij installeren hoogwaardige HD camera\'s met kristalhelder beeld, zelfs bij slecht weer en in het donker dankzij nachtzicht technologie. De camera wordt volledig geïntegreerd met uw bestaande scherm of wij installeren een nieuw display. Inclusief dynamische parkeerhulplijnen die meebewegen met uw stuurwiel, zodat u altijd precies weet waar u naartoe rijdt. Perfect voor grotere auto\'s, SUV\'s, bestelwagens of auto\'s met beperkt zicht naar achteren. Wij bedienen heel de regio Antwerpen: Wommelgem, Mortsel, Kontich, Edegem, Schoten, Brasschaat, Wijnegem, Deurne, Berchem en omstreken. Backup camera installeren Antwerpen - voor maximale veiligheid en gemak.',
      benefits: [
        'HD beeldkwaliteit (1080p) - achteruitrijcamera Antwerpen',
        'Nachtzicht voor zicht in het donker',
        'Dynamische parkeerhulplijnen (bewegen met stuur)',
        'Waterdicht en schokbestendig (IP68/IP69K)',
        'Integratie met bestaand scherm of nieuw display',
        'Automatische activering bij achteruit schakelen',
      ],
      useCases: [
        { title: 'Parkeren', desc: 'Veilig inparkeren in krappe ruimtes - Antwerpen' },
        { title: 'Manoeuvreren', desc: 'Overzicht van obstakels en personen' },
        { title: 'Aanhanger', desc: 'Gemakkelijk koppelen van aanhanger of caravan' },
        { title: 'Nauwe ruimtes', desc: 'Manoeuvreren in krappe parkeergarages' },
      ],
      image: 'https://static.readdy.ai/image/9e62058216dff63d1a686833c97014ce/3d64f136a9894c3e464cb63a8fd00377.jpeg',
      features: [
        { icon: 'ri-hd-line', title: 'HD kwaliteit', desc: '1080p resolutie' },
        { icon: 'ri-moon-line', title: 'Nachtzicht', desc: 'Ook in het donker' },
        { icon: 'ri-guide-line', title: 'Parkeerlijnen', desc: 'Dynamische hulplijnen' },
        { icon: 'ri-shield-check-line', title: 'Waterdicht', desc: 'IP68/IP69K' },
      ],
      color: 'from-orange-400 to-red-500',
      glowColor: 'orange',
    },
  ];

  const schema = {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "Sterrenhemel & Sfeerverlichting Installatie Antwerpen - DSF Cartech",
    "description": "Professionele sterrenhemel installeren, sfeerverlichting auto installeren en achteruitrijcamera installatie in Antwerpen. Interieur upgrades voor alle automerken in regio Antwerpen.",
    "provider": {
      "@type": "LocalBusiness",
      "name": "DSF Cartech",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Ternesselei 191",
        "addressLocality": "Wommelgem",
        "addressRegion": "Antwerpen",
        "postalCode": "2160",
        "addressCountry": "BE"
      },
      "telephone": "+32489170592",
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": "51.2194",
        "longitude": "4.4025"
      }
    },
    "areaServed": {
      "@type": "City",
      "name": "Antwerpen"
    },
    "serviceType": ["Sterrenhemel installatie Antwerpen", "Sfeerverlichting auto installeren", "Achteruitrijcamera installatie", "Ambient lighting auto"]
  };

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "Waar kan ik een sterrenhemel laten installeren in Antwerpen?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Bij DSF Cartech in Wommelgem (Antwerpen) kunt u terecht voor professionele sterrenhemel installatie. Wij bedienen de hele regio Antwerpen inclusief Mortsel, Kontich, Edegem, Schoten en Brasschaat."
        }
      },
      {
        "@type": "Question",
        "name": "Hoeveel kost sfeerverlichting installeren in Antwerpen?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "De prijs voor sfeerverlichting installatie in Antwerpen varieert afhankelijk van het aantal locaties en uw automodel. Neem contact op voor een vrijblijvende offerte."
        }
      },
      {
        "@type": "Question",
        "name": "Kan ik een achteruitrijcamera laten installeren in mijn oude auto?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Ja, wij kunnen in vrijwel elke auto een achteruitrijcamera installeren, ook in oudere modellen. De camera wordt geïntegreerd met uw bestaande scherm of wij installeren een nieuw display."
        }
      }
    ]
  };

  return (
    <>
      <SEOHead
        title="Sterrenhemel installatie Antwerpen ✓ Sfeerverlichting auto installeren ✓ Achteruitrijcamera ✓ Ambient lighting voor alle merken ✓ Professionele interieur upgrades ✓ DSF Cartech Wommelgem"
        description="Sterrenhemel installatie Antwerpen ✓ Sfeerverlichting auto installeren ✓ Achteruitrijcamera ✓ Ambient lighting voor alle merken ✓ Professionele interieur upgrades ✓ DSF Cartech Wommelgem"
        keywords="sterrenhemel installeren antwerpen, sterrenhemel auto antwerpen, sfeerverlichting auto installeren antwerpen, ambient lighting antwerpen, achteruitrijcamera installeren antwerpen, backup camera antwerpen, interieur verlichting auto antwerpen, led strips auto antwerpen, sterrenhemel plafond auto, sfeerverlichting installatie antwerpen"
        canonical={`${siteUrl}/diensten/sterrenhemel-sfeerverlichting-achteruitcamera-in-antwerpen`}
        schema={schema}
      />

      <div className="bg-black text-white min-h-screen">
        <Navigation />

        {/* Hero Section */}
        <section className="relative pt-24 md:pt-32 pb-12 md:pb-20 overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-b from-purple-950/20 via-black to-black"></div>
          
          <div className="absolute inset-0 opacity-20">
            <div className="absolute top-20 left-1/4 w-96 h-96 bg-purple-500/30 rounded-full blur-3xl"></div>
            <div className="absolute bottom-20 right-1/4 w-96 h-96 bg-pink-500/30 rounded-full blur-3xl"></div>
          </div>

          <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 relative z-10">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              className="text-center"
            >
              <motion.div
                initial={{ scale: 0.8, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                transition={{ duration: 0.6, delay: 0.2 }}
                className="inline-block mb-4 md:mb-6"
              >
                <div className="px-4 md:px-6 py-2 bg-gradient-to-r from-purple-500/20 to-pink-500/20 border-2 border-purple-400/50 rounded-full backdrop-blur-sm">
                  <span className="text-purple-300 text-xs md:text-sm font-bold tracking-widest uppercase">Interieur Upgrades Antwerpen</span>
                </div>
              </motion.div>

              <h1 className="text-3xl md:text-5xl lg:text-7xl font-bold mb-4 md:mb-6 leading-tight px-4" style={{ fontFamily: 'Orbitron, monospace' }}>
                <span className="text-white">Sterrenhemel Installeren</span>
                <br />
                <span className="bg-gradient-to-r from-purple-300 via-pink-300 to-purple-300 bg-clip-text text-transparent">
                  Antwerpen
                </span>
              </h1>

              <p className="text-base md:text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed px-4 mb-6">
                <strong>Sterrenhemel installatie Antwerpen</strong>, <strong>sfeerverlichting auto installeren</strong> en achteruitrijcamera's door DSF Cartech. Luxe interieur upgrades voor alle automerken in regio Antwerpen.
              </p>

              <p className="text-sm md:text-base text-gray-400 max-w-2xl mx-auto px-4">
                Wij bedienen: Wommelgem, Mortsel, Kontich, Edegem, Schoten, Brasschaat, Wijnegem, Deurne, Berchem en heel Antwerpen
              </p>
            </motion.div>
          </div>
        </section>

        {/* Services Navigation */}
        <section className="sticky top-16 md:top-20 z-40 bg-black/95 backdrop-blur-xl border-b border-white/10">
          <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
            <div className="flex overflow-x-auto gap-2 py-3 md:py-4 scrollbar-hide">
              {services.map((service, index) => (
                <motion.button
                  key={service.id}
                  onClick={() => {
                    setActiveService(index);
                    document.getElementById(service.id)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
                  }}
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  className={`flex items-center gap-2 px-4 md:px-6 py-2 md:py-3 rounded-xl whitespace-nowrap transition-all duration-300 cursor-pointer ${
                    activeService === index
                      ? `bg-gradient-to-r ${service.color} text-white shadow-lg`
                      : 'bg-white/5 text-gray-400 hover:bg-white/10 hover:text-white'
                  }`}
                >
                  <i className={`${service.icon} text-base md:text-lg`}></i>
                  <span className="font-semibold text-xs md:text-sm">{service.title}</span>
                </motion.button>
              ))}
            </div>
          </div>
        </section>

        {/* Services Details */}
        <section className="py-12 md:py-20">
          <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 space-y-20 md:space-y-32">
            {services.map((service, index) => (
              <motion.div
                key={service.id}
                id={service.id}
                initial={{ opacity: 0, y: 60 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
                viewport={{ once: true, margin: "-100px" }}
                className="relative"
              >
                <div className={`absolute inset-0 bg-gradient-to-br ${service.color} opacity-5 blur-3xl rounded-3xl`}></div>

                <div className={`relative grid lg:grid-cols-2 gap-8 md:gap-12 items-center ${index % 2 === 1 ? 'lg:flex-row-reverse' : ''}`}>
                  <motion.div
                    initial={{ opacity: 0, x: index % 2 === 0 ? -40 : 40 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.8, delay: 0.2 }}
                    viewport={{ once: true }}
                    className={`relative ${index % 2 === 1 ? 'lg:order-2' : ''}`}
                  >
                    <div className="relative group">
                      <div className={`absolute -inset-4 bg-gradient-to-br ${service.color} opacity-20 blur-2xl group-hover:opacity-30 transition-opacity duration-500 rounded-3xl`}></div>
                      <div className="relative overflow-hidden rounded-2xl border-2 border-white/10">
                        <img
                          src={service.image}
                          alt={service.title}
                          className="w-full h-64 md:h-96 object-cover transform group-hover:scale-105 transition-transform duration-700"
                        />
                      </div>
                    </div>
                  </motion.div>

                  <motion.div
                    initial={{ opacity: 0, x: index % 2 === 0 ? 40 : -40 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.8, delay: 0.3 }}
                    viewport={{ once: true }}
                    className={index % 2 === 1 ? 'lg:order-1' : ''}
                  >
                    <div className="flex items-center gap-3 md:gap-4 mb-4 md:mb-6">
                      <div className={`w-12 h-12 md:w-16 md:h-16 flex items-center justify-center bg-gradient-to-br ${service.color} rounded-2xl shadow-2xl`}>
                        <i className={`${service.icon} text-2xl md:text-3xl text-white`}></i>
                      </div>
                      <div>
                        <h2 className="text-2xl md:text-4xl font-bold text-white" style={{ fontFamily: 'Orbitron, monospace' }}>
                          {service.title}
                        </h2>
                        <p className={`text-sm md:text-lg bg-gradient-to-r ${service.color} bg-clip-text text-transparent font-semibold`}>
                          {service.subtitle}
                        </p>
                      </div>
                    </div>

                    <p className="text-base md:text-lg text-gray-300 leading-relaxed mb-4 md:mb-6">
                      {service.description}
                    </p>

                    <p className="text-sm md:text-base text-gray-400 leading-relaxed mb-6 md:mb-8">
                      {service.longDescription}
                    </p>

                    {service.id === 'sfeerverlichting' && (
                      <div className="mb-6 md:mb-8 p-4 md:p-5 bg-gradient-to-r from-pink-500/10 to-rose-500/10 border border-pink-500/30 rounded-xl">
                        <div className="flex items-start gap-3">
                          <i className="ri-information-line text-pink-400 text-xl mt-1 flex-shrink-0"></i>
                          <div>
                            <h4 className="text-white font-semibold text-sm md:text-base mb-2">Bediening via origineel scherm</h4>
                            <p className="text-gray-300 text-xs md:text-sm leading-relaxed">
                              Bij veel Duitse merken zoals <strong>Mercedes, Audi, Volkswagen, Porsche en Seat</strong> kan de sfeerverlichting vaak direct via het originele scherm van uw auto bediend worden. 
                              Dit zorgt voor een volledig geïntegreerde en luxe ervaring. <strong>Neem contact op</strong> om te controleren of dit mogelijk is voor uw specifieke model.
                            </p>
                          </div>
                        </div>
                      </div>
                    )}

                    <div className="grid grid-cols-2 gap-3 md:gap-4 mb-6 md:mb-8">
                      {service.features.map((feature, idx) => (
                        <motion.div
                          key={idx}
                          initial={{ opacity: 0, y: 20 }}
                          whileInView={{ opacity: 1, y: 0 }}
                          transition={{ duration: 0.5, delay: 0.4 + idx * 0.1 }}
                          viewport={{ once: true }}
                          className="p-3 md:p-4 bg-white/5 backdrop-blur-sm rounded-xl border border-white/10 hover:bg-white/10 transition-all duration-300"
                        >
                          <i className={`${feature.icon} text-xl md:text-2xl bg-gradient-to-r ${service.color} bg-clip-text text-transparent mb-2`}></i>
                          <h4 className="text-white font-semibold text-xs md:text-sm mb-1">{feature.title}</h4>
                          <p className="text-gray-400 text-xs">{feature.desc}</p>
                        </motion.div>
                      ))}
                    </div>

                    <motion.button
                      whileHover={{ scale: 1.05 }}
                      whileTap={{ scale: 0.95 }}
                      onClick={() => window.REACT_APP_NAVIGATE('/contact')}
                      className={`w-full md:w-auto px-6 md:px-8 py-3 md:py-4 bg-gradient-to-r ${service.color} text-white font-bold rounded-xl whitespace-nowrap cursor-pointer shadow-2xl hover:shadow-3xl transition-all duration-300`}
                    >
                      <span className="flex items-center justify-center gap-2">
                        <i className="ri-calendar-check-line text-lg md:text-xl"></i>
                        <span className="text-sm md:text-base">Maak een Afspraak</span>
                      </span>
                    </motion.button>
                  </motion.div>
                </div>

                <motion.div
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8, delay: 0.4 }}
                  viewport={{ once: true }}
                  className="mt-12 md:mt-16 grid md:grid-cols-2 gap-6 md:gap-8"
                >
                  <div className="p-6 md:p-8 bg-white/5 backdrop-blur-sm rounded-2xl border border-white/10">
                    <h3 className="text-xl md:text-2xl font-bold text-white mb-4 md:mb-6 flex items-center gap-3">
                      <i className="ri-checkbox-circle-line text-2xl md:text-3xl bg-gradient-to-r from-purple-400 to-pink-500 bg-clip-text text-transparent"></i>
                      <span>Voordelen</span>
                    </h3>
                    <ul className="space-y-3 md:space-y-4">
                      {service.benefits.map((benefit, idx) => (
                        <motion.li
                          key={idx}
                          initial={{ opacity: 0, x: -20 }}
                          whileInView={{ opacity: 1, x: 0 }}
                          transition={{ duration: 0.5, delay: idx * 0.1 }}
                          viewport={{ once: true }}
                          className="flex items-start gap-3 text-gray-300"
                        >
                          <i className={`ri-check-line text-lg md:text-xl bg-gradient-to-r ${service.color} bg-clip-text text-transparent mt-1 flex-shrink-0`}></i>
                          <span className="text-xs md:text-sm leading-relaxed">{benefit}</span>
                        </motion.li>
                      ))}
                    </ul>
                  </div>

                  <div className="p-6 md:p-8 bg-white/5 backdrop-blur-sm rounded-2xl border border-white/10">
                    <h3 className="text-xl md:text-2xl font-bold text-white mb-4 md:mb-6 flex items-center gap-3">
                      <i className="ri-lightbulb-line text-2xl md:text-3xl bg-gradient-to-r from-purple-400 to-pink-500 bg-clip-text text-transparent"></i>
                      <span>Toepassingen</span>
                    </h3>
                    <div className="space-y-3 md:space-y-4">
                      {service.useCases.map((useCase, idx) => (
                        <motion.div
                          key={idx}
                          initial={{ opacity: 0, x: 20 }}
                          whileInView={{ opacity: 1, x: 0 }}
                          transition={{ duration: 0.5, delay: idx * 0.1 }}
                          viewport={{ once: true }}
                          className="p-3 md:p-4 bg-white/5 rounded-xl border border-white/5 hover:bg-white/10 transition-all duration-300"
                        >
                          <h4 className={`text-white font-semibold text-xs md:text-sm mb-1 bg-gradient-to-r ${service.color} bg-clip-text text-transparent`}>
                            {useCase.title}
                          </h4>
                          <p className="text-gray-400 text-xs leading-relaxed">{useCase.desc}</p>
                        </motion.div>
                      ))}
                    </div>
                  </div>
                </motion.div>
              </motion.div>
            ))}
          </div>
        </section>

        {/* Local SEO Content Section */}
        <section className="py-12 md:py-20 bg-gradient-to-b from-black to-gray-900">
          <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="text-center mb-12"
            >
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" style={{ fontFamily: 'Orbitron, monospace' }}>
                <strong>Interieur Upgrades Antwerpen</strong> - Uw Specialist
              </h2>
              <p className="text-base md:text-lg text-gray-300 max-w-4xl mx-auto leading-relaxed">
                DSF Cartech is dé specialist voor <strong>sterrenhemel installeren Antwerpen</strong>, <strong>sfeerverlichting auto installatie</strong> en achteruitrijcamera's. 
                Met jarenlange ervaring in luxe auto-interieur upgrades bedienen wij klanten in heel de regio Antwerpen.
              </p>
            </motion.div>

            <div className="grid md:grid-cols-2 gap-8 mb-12">
              <motion.div
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6 }}
                viewport={{ once: true }}
                className="p-6 md:p-8 bg-white/5 backdrop-blur-sm rounded-2xl border border-white/10"
              >
                <h3 className="text-xl md:text-2xl font-bold text-white mb-4 flex items-center gap-3">
                  <i className="ri-map-pin-line text-2xl text-purple-400"></i>
                  <span>Regio Antwerpen</span>
                </h3>
                <p className="text-gray-300 leading-relaxed mb-4">
                  <strong>Sterrenhemel installeren Antwerpen</strong> en omstreken? Wij komen naar u toe of u komt langs in Wommelgem. 
                  Onze interieur upgrade service is beschikbaar in:
                </p>
                <ul className="grid grid-cols-2 gap-2 text-sm text-gray-400">
                  <li className="flex items-center gap-2"><i className="ri-check-line text-purple-400"></i> Wommelgem</li>
                  <li className="flex items-center gap-2"><i className="ri-check-line text-purple-400"></i> Mortsel</li>
                  <li className="flex items-center gap-2"><i className="ri-check-line text-purple-400"></i> Kontich</li>
                  <li className="flex items-center gap-2"><i className="ri-check-line text-purple-400"></i> Edegem</li>
                  <li className="flex items-center gap-2"><i className="ri-check-line text-purple-400"></i> Schoten</li>
                  <li className="flex items-center gap-2"><i className="ri-check-line text-purple-400"></i> Brasschaat</li>
                  <li className="flex items-center gap-2"><i className="ri-check-line text-purple-400"></i> Wijnegem</li>
                  <li className="flex items-center gap-2"><i className="ri-check-line text-purple-400"></i> Deurne</li>
                  <li className="flex items-center gap-2"><i className="ri-check-line text-purple-400"></i> Berchem</li>
                  <li className="flex items-center gap-2"><i className="ri-check-line text-purple-400"></i> Antwerpen</li>
                </ul>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, x: 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6 }}
                viewport={{ once: true }}
                className="p-6 md:p-8 bg-white/5 backdrop-blur-sm rounded-2xl border border-white/10"
              >
                <h3 className="text-xl md:text-2xl font-bold text-white mb-4 flex items-center gap-3">
                  <i className="ri-car-line text-2xl text-pink-400"></i>
                  <span>Alle Automerken</span>
                </h3>
                <p className="text-gray-300 leading-relaxed mb-4">
                  <strong>Sfeerverlichting installeren Antwerpen</strong> voor alle merken. Wij hebben ervaring met:
                </p>
                <ul className="grid grid-cols-2 gap-2 text-sm text-gray-400">
                  <li className="flex items-center gap-2"><i className="ri-check-line text-pink-400"></i> Rolls-Royce</li>
                  <li className="flex items-center gap-2"><i className="ri-check-line text-pink-400"></i> Bentley</li>
                  <li className="flex items-center gap-2"><i className="ri-check-line text-pink-400"></i> BMW</li>
                  <li className="flex items-center gap-2"><i className="ri-check-line text-pink-400"></i> Mercedes</li>
                  <li className="flex items-center gap-2"><i className="ri-check-line text-pink-400"></i> Audi</li>
                  <li className="flex items-center gap-2"><i className="ri-check-line text-pink-400"></i> Volkswagen</li>
                  <li className="flex items-center gap-2"><i className="ri-check-line text-pink-400"></i> Ford</li>
                  <li className="flex items-center gap-2"><i className="ri-check-line text-pink-400"></i> Opel</li>
                  <li className="flex items-center gap-2"><i className="ri-check-line text-pink-400"></i> Toyota</li>
                  <li className="flex items-center gap-2"><i className="ri-check-line text-pink-400"></i> En meer...</li>
                </ul>
              </motion.div>
            </div>

            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
              className="p-6 md:p-8 bg-gradient-to-r from-purple-500/10 to-pink-500/10 backdrop-blur-sm rounded-2xl border border-purple-400/30"
            >
              <h3 className="text-2xl md:text-3xl font-bold text-white mb-4 text-center">
                Waarom Kiezen voor DSF Cartech?
              </h3>
              <div className="grid md:grid-cols-3 gap-6 mt-8">
                <div className="text-center">
                  <div className="w-16 h-16 mx-auto mb-4 bg-gradient-to-br from-purple-400 to-pink-500 rounded-full flex items-center justify-center">
                    <i className="ri-vip-crown-line text-3xl text-white"></i>
                  </div>
                  <h4 className="text-lg font-bold text-white mb-2">Luxe Kwaliteit</h4>
                  <p className="text-sm text-gray-400">Hoogwaardige materialen en perfecte afwerking</p>
                </div>
                <div className="text-center">
                  <div className="w-16 h-16 mx-auto mb-4 bg-gradient-to-br from-purple-400 to-pink-500 rounded-full flex items-center justify-center">
                    <i className="ri-tools-line text-3xl text-white"></i>
                  </div>
                  <h4 className="text-lg font-bold text-white mb-2">Vakmanschap</h4>
                  <p className="text-sm text-gray-400">Jarenlange ervaring in interieur upgrades</p>
                </div>
                <div className="text-center">
                  <div className="w-16 h-16 mx-auto mb-4 bg-gradient-to-br from-purple-400 to-pink-500 rounded-full flex items-center justify-center">
                    <i className="ri-map-pin-2-line text-3xl text-white"></i>
                  </div>
                  <h4 className="text-lg font-bold text-white mb-2">Lokaal</h4>
                  <p className="text-sm text-gray-400">Gevestigd in Antwerpen, snel bereikbaar</p>
                </div>
              </div>
            </motion.div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="py-12 md:py-20 bg-black">
          <div className="max-w-4xl mx-auto px-4 md:px-6 lg:px-8">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="text-center mb-12"
            >
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" style={{ fontFamily: 'Orbitron, monospace' }}>
                Veelgestelde Vragen
              </h2>
              <p className="text-gray-400">Over sterrenhemel, sfeerverlichting en achteruitrijcamera installatie in Antwerpen</p>
            </motion.div>

            <div className="space-y-4">
              {[
                {
                  q: "Waar kan ik een sterrenhemel laten installeren in Antwerpen?",
                  a: "Bij DSF Cartech in Wommelgem (Antwerpen) kunt u terecht voor professionele sterrenhemel installatie. Wij bedienen de hele regio Antwerpen inclusief Mortsel, Kontich, Edegem, Schoten en Brasschaat."
                },
                {
                  q: "Hoeveel kost sfeerverlichting installeren in Antwerpen?",
                  a: "De prijs voor sfeerverlichting installatie in Antwerpen varieert afhankelijk van het aantal locaties en uw automodel. Neem contact op voor een vrijblijvende offerte."
                },
                {
                  q: "Kan ik een achteruitrijcamera laten installeren in mijn oude auto?",
                  a: "Ja, wij kunnen in vrijwel elke auto een achteruitrijcamera installeren, ook in oudere modellen. De camera wordt geïntegreerd met uw bestaande scherm of wij installeren een nieuw display."
                },
                {
                  q: "Hoe lang duurt een sterrenhemel installatie?",
                  a: "Een sterrenhemel installatie duurt gemiddeld 1-2 dagen, afhankelijk van de complexiteit en het aantal sterren. Wij werken nauwkeurig om een perfect resultaat te garanderen."
                },
                {
                  q: "Is sfeerverlichting ook mogelijk in oudere auto's?",
                  a: "Ja, wij kunnen sfeerverlichting installeren in vrijwel elke auto, ongeacht het bouwjaar. De installatie wordt volledig op maat gemaakt voor uw specifieke model."
                },
                {
                  q: "Beschadigt de installatie mijn auto-interieur?",
                  a: "Nee, wij werken zeer zorgvuldig en professioneel. Alle installaties worden uitgevoerd zonder schade aan uw interieur. Wij gebruiken de juiste technieken en materialen."
                }
              ].map((faq, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  viewport={{ once: true }}
                  className="p-6 bg-white/5 backdrop-blur-sm rounded-xl border border-white/10 hover:bg-white/10 transition-all duration-300"
                >
                  <h4 className="text-lg font-bold text-white mb-3 flex items-start gap-3">
                    <i className="ri-question-line text-purple-400 text-xl mt-1 flex-shrink-0"></i>
                    <span>{faq.q}</span>
                  </h4>
                  <p className="text-gray-400 leading-relaxed pl-9">{faq.a}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="relative py-20 md:py-32 overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-b from-black via-purple-950/20 to-black"></div>
          
          <div className="absolute inset-0 opacity-20">
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-purple-500/40 rounded-full blur-3xl"></div>
          </div>

          <div className="max-w-4xl mx-auto px-4 md:px-6 lg:px-8 relative z-10 text-center">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold mb-4 md:mb-6 text-white" style={{ fontFamily: 'Orbitron, monospace' }}>
                Klaar voor <span className="bg-gradient-to-r from-purple-300 to-pink-300 bg-clip-text text-transparent">Interieur Upgrade?</span>
              </h2>
              <p className="text-base md:text-xl text-gray-300 mb-8 md:mb-12 leading-relaxed px-4">
                <strong>Sterrenhemel installeren Antwerpen</strong>, <strong>sfeerverlichting auto</strong> of achteruitrijcamera? 
                Neem contact op voor een vrijblijvend adviesgesprek en ontdek wat wij voor uw auto kunnen betekenen.
              </p>

              <div className="flex flex-col sm:flex-row gap-4 md:gap-6 justify-center px-4">
                <motion.button
                  whileHover={{ scale: 1.05, y: -2 }}
                  whileTap={{ scale: 0.98 }}
                  onClick={() => window.REACT_APP_NAVIGATE('/contact')}
                  className="w-full sm:w-auto px-8 md:px-12 py-4 md:py-5 bg-gradient-to-r from-purple-500 to-pink-500 text-white text-base md:text-lg font-bold rounded-2xl whitespace-nowrap cursor-pointer shadow-2xl shadow-purple-500/50 hover:shadow-purple-500/70 transition-all duration-300"
                >
                  <span className="flex items-center justify-center gap-3">
                    <i className="ri-calendar-check-line text-xl md:text-2xl"></i>
                    <span>Maak een Afspraak</span>
                  </span>
                </motion.button>

                <motion.a
                  href="tel:+32489170592"
                  whileHover={{ scale: 1.05, y: -2 }}
                  whileTap={{ scale: 0.98 }}
                  className="w-full sm:w-auto px-8 md:px-12 py-4 md:py-5 bg-white/10 backdrop-blur-xl border-2 border-white/30 text-white text-base md:text-lg font-bold rounded-2xl whitespace-nowrap cursor-pointer hover:bg-white/20 transition-all duration-300 shadow-lg hover:shadow-xl"
                >
                  <span className="flex items-center justify-center gap-3">
                    <i className="ri-phone-line text-xl md:text-2xl"></i>
                    <span>Bel Direct</span>
                  </span>
                </motion.a>
              </div>
            </motion.div>
          </div>
        </section>

        <Footer />
      </div>

      {/* Add FAQ Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
    </>
  );
}
